import React, { useEffect, useState } from "react";
import ReactPaginate from "react-paginate";


const LearnUserListTable = () => {


    return (
        <>
            <div className="tr-odd-wallet" sstyle={{ overflowX: "auto" }}>
                <table className="table w-100">
                    <thead className="bg-warning">
                        <tr>
                            <th scope="col" className="text-black fw-bold">
                                #
                            </th>
                            <th scope="col" className="text-black fw-bold">
                                User ID
                            </th>
                            <th scope="col" className="text-black fw-bold">
                                Name
                            </th>
                            <th scope="col" className="text-black fw-bold">
                                Action
                            </th>
                        </tr>
                    </thead>
                    <tbody>

                        <tr className="tr-child-wallet">
                            <td>1</td>
                            <td>234732</td>
                            <td>Sharwar Janan</td>
                            <td >
                                <i class="fa-solid fa-trash-can btn btn-danger"></i>
                            </td>
                        </tr>

                        <tr className="tr-child-wallet">
                            <td>1</td>
                            <td>234732</td>
                            <td>Sharwar Janan</td>
                            <td >
                                <i class="fa-solid fa-trash-can btn btn-danger"></i>
                            </td>
                        </tr>

                        <tr className="tr-child-wallet">
                            <td>1ee</td>
                            <td>234732fdsf ds</td>
                            <td>Sharwarfs dfsdf sd Janan</td>
                            <td >
                                <i class="fa-solid fa-trash-can btn btn-danger"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </>
    )
}

export default LearnUserListTable